import getLocalString from "constants/Localization";
import { useGetReportSalesByProductSummaryMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportSalesByProductSummary = (showSuccessMessage: boolean = true) => {
  const [mutation, { loading, data, error }] = useGetReportSalesByProductSummaryMutation();
  const [getReportSalesByProductSummary, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportSalesByProductSummary",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportSalesByProductSummary, { ...context, data }] as const;
};

export default useGetReportSalesByProductSummary;
